import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnvelope = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 13 10",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M12 1.25C12 .56 11.46 0 10.8 0H1.2C.54 0 0 .56 0 1.25v7.5C0 9.44.54 10 1.2 10h9.6c.66 0 1.2-.56 1.2-1.25v-7.5zm-1.2 0L6 4.38 1.2 1.25h9.6zM6 5.63L1.2 2.5v6.25h9.6V2.5L6 5.63z"
	})
});
export default SvgEnvelope;
